exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbody.overflowHidden {\n    overflow: hidden !important;\n}\n", ""]);

// exports
